import React from 'react';
import PropTypes from 'prop-types';

import Button from "UI/Button";
import Modal from "UI/Modal";

export default class NewSlideDialog extends React.Component
{
    static propTypes = {
        storyId: PropTypes.string.isRequired,
        createSlide: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired,
    };

    handleAddSlide = (type) => {
        this.props.createSlide(this.props.storyId, type).then(slide => {
            this.props.onClose(slide.id);
        });
    };

    render()
    {
        const {open, onClose} = this.props;

        return <Modal open={open} onClose={onClose}>
            <Modal.Header>
                New Slide
            </Modal.Header>
            <Modal.Content>
                Select the type of Slide you would like to add.
                <div className='flex justify-between mt-4'>
                    <img className='cursor-pointer rounded shadow relative h-32' src="/img/layer-only-image.png" onClick={() => this.handleAddSlide('fullimage')} />
                    <img className='cursor-pointer rounded shadow relative h-32' src="/img/layer-image-with-text.png" onClick={() => this.handleAddSlide('default')} />
                    <img className='cursor-pointer rounded shadow relative h-32' src="/img/layer-only-text.png" onClick={() => this.handleAddSlide('fulltext')} />
                </div>
            </Modal.Content>
            <Modal.Footer>
                <Button onClick={onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>;
    }
}
